import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

const VITE_BACKEND_GRAPHQL_URL = import.meta.env.VITE_PUBLIC_BACKEND_URL + '/api/graphql/'

export const useApolloClient = (setStatusCode: (status: number) => void): ApolloClient<any> => {
  const httpLink = new HttpLink({
    credentials: 'include',
    uri: VITE_BACKEND_GRAPHQL_URL,
  })

  // Error handling link to intercept network errors
  const errorLink = onError(({ networkError, graphQLErrors }) => {
    if (networkError && 'statusCode' in networkError) {
      setStatusCode(networkError.statusCode) // Update auth status code on network error
    } else if (graphQLErrors && graphQLErrors.length > 0) {
      setStatusCode(400)
    } else {
      setStatusCode(500)
    }
  })

  const link = ApolloLink.from([errorLink, httpLink])

  // Apollo Client initialization
  return new ApolloClient({
    cache: new InMemoryCache(),
    link,
  })
}
